import { COLORS } from '../../constants/colors';
import { linearGradientToTuples } from '../../utils/gradientColor';
export const stops = {
    pink: linearGradientToTuples(COLORS.GRADIENT.PINK),
    green: linearGradientToTuples(COLORS.GRADIENT.GREEN),
    blue: linearGradientToTuples(COLORS.GRADIENT.BLUE),
    purple: linearGradientToTuples(COLORS.GRADIENT.PURPLE),
    rainbow: linearGradientToTuples(COLORS.GRADIENT['RAINBOW-HORIZONTAL']),
};
